import {createContext, FC, PropsWithChildren, useContext, useState} from 'react'

type AssignmentAgreementContextValue = {
  hasAssignmentAgreement: boolean
  setHasAssignmentAgreement: (hasAssignmentAgreement: boolean) => void
}

const AssignmentAgreementContext = createContext<AssignmentAgreementContextValue | null>(null)

export const AssignmentAgreementProvider: FC<PropsWithChildren> = ({children}) => {
  const [hasAssignmentAgreement, setHasAssignmentAgreement] = useState(false)

  return (
    <AssignmentAgreementContext.Provider
      value={{hasAssignmentAgreement, setHasAssignmentAgreement}}
    >
      {children}
    </AssignmentAgreementContext.Provider>
  )
}

export const useAssignmentAgreement = (): AssignmentAgreementContextValue => {
  const context = useContext(AssignmentAgreementContext)

  if (!context) {
    throw new Error('useAssignmentAgreement must be used within an AssignmentAgreementProvider')
  }

  return context
}
